var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        title: "Switch Team",
        "ok-title": "Switch",
        "ok-disabled": !_setup.selectedUsername,
        scrollable: false,
      },
      on: { ok: _setup.onSwitch },
      model: {
        value: _setup.isOpen,
        callback: function ($$v) {
          _setup.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c(_setup.CSelect, {
        attrs: {
          label: "Team account",
          placeholder: "Select an account",
          "append-to-body": "",
          searchable: "",
          options: _setup.options,
          "model-transform": _setup.valueReducer,
        },
        model: {
          value: _setup.selectedUsername,
          callback: function ($$v) {
            _setup.selectedUsername = $$v
          },
          expression: "selectedUsername",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }